<template>
  <div class="ticker flex overflow-hidden">
    <div class="animate-ticker">
      <!-- Duplicate the content for a seamless loop -->
      <span v-for="n in 60" :key="n" class="ticker-item font-title text-white"
        >$AKITTY</span
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    duration: {
      type: Number,
      default: 20, // Adjusted to accommodate the length of the animation
    },
  },
};
</script>

<style scoped>
@keyframes scroll {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(
      -50%
    ); /* Adjust this value based on trial and error */
  }
}
.ticker {
  @apply relative w-full;
}
.animate-ticker {
  animation: scroll linear infinite;
  animation-duration: var(--ticker-duration, 20s);
}

.ticker-item {
  @apply mr-8; /* This creates gaps between each item. Adjust as needed. */
  font-size: 1.2rem;
  font-weight: bold;
}

.logo-img {
  @apply h-20; /* Adjust height as necessary */
}
</style>
